import React, { useState } from "react";
import { Box } from "@mui/system";
import { Skeleton, Typography } from "@mui/material";
import useSWR from "swr";
import { useNavigate, useParams } from "react-router";
import { memo } from "react";
import { useDispatch } from "react-redux";

import TopicCart from "../TopicCart";
import RightLeftChecker from "../../../../utils/RightLeftChecker";
import AvatarList from "../../AvatarList";
import {
  setTableModalTab,
  setThoughtTab,
} from "../../../../redux/features/settingSlice";
import PlayAllButton from "../PlayAllButton";
import CustomHelmet from "../../CustomHelmet";
import { fetcherGetToken } from "../../../../services/fetcher";

const DiscussionDetailPage = memo(() => {
  const [openDes, setOpenDes] = useState(false);
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const tokenStorage = JSON.parse(localStorage.getItem("token")) || null;

  const handleGoToTable = () => {
    navigate(`/table/${params.tableId}`);
    dispatch(setTableModalTab(0));
    dispatch(setThoughtTab(0));
  };

  const { data: table, isLoading: tableLoading } = useSWR(
    [
      `${process.env.REACT_APP_API}/content/table/${params.tableId}/`,
      tokenStorage,
    ],
    fetcherGetToken
  );

  const { data: discussionDetail, isLoading } = useSWR(
    `${process.env.REACT_APP_API}/content/conversation/${params.discussionId}/`,
    {
      dedupingInterval: 6000,
      refreshInterval: 18000,
    }
  );

  return (
    <>
      {discussionDetail && (
        <CustomHelmet title={`${discussionDetail.title} | Discussion`} />
      )}

      <Box
        sx={{
          backgroundColor: "white.main",
          border: "2px solid",
          borderColor: "black.main",
          borderRadius: "16px 16px 0 0",
          height: "100vh",
          top: 64,
          position: "fixed",
          width: "100%",
          padding: "16px 16px 0px 16px",
          zIndex: 2,
        }}
      >
        <Box
          onClick={() => handleGoToTable()}
          sx={{
            position: "absolute",
            top: -47,
            height: 45,
            backgroundColor: "white.main",
            opacity: 0.8,
            borderRadius: "16px 16px 0 0",
            right: 75,
            left: 75,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            border: "2px solid",
            borderColor: "black.main",
            borderBottom: "0",
            cursor: "pointer",
          }}
        >
          {(tableLoading || !table) && (
            <Skeleton
              width={200}
              height={40}
              sx={{
                mr: "8px",
              }}
            />
          )}
          {!tableLoading && table && (
            <Typography
              noWrap
              sx={{
                fontFamily: "Tahrir",
                fontWeight: 500,
                fontSize: 20,
                lineHeight: "24px",
                color: "black.main",
                pl: "8px",
                pr: "8px",
                direction: RightLeftChecker(table.title) ? "rtl" : "ltr",
              }}
            >
              {table.title}
            </Typography>
          )}
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mb: "8px",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Box sx={{ mr: "8px" }}>
              <AvatarList avatarData={discussionDetail} type='discussion' />
            </Box>
          </Box>
          <PlayAllButton />
        </Box>

        <TopicCart
          type='discussion'
          loading={isLoading}
          data={discussionDetail}
          openDes={openDes}
          setOpenDes={setOpenDes}
        />
      </Box>
    </>
  );
});
export default DiscussionDetailPage;
